import { useGetCompetitionLeaderboard } from '@pkg/hooks';

import { type Competition } from '@app/client';

export function useLeaderboardCount(competition?: Competition) {
    const { data: leaderboardData } = useGetCompetitionLeaderboard({
        query: '',
        ignoreSignal: true,
        slug: competition?.slug,
        disabled: !competition || !competition?.multigame,
    });

    return leaderboardData?.pages?.[0]?.paging?.total || 0;
}
